module.exports = __webpack_public_path__ + "static/media/Tasks.b6798d63.png";